import { Label } from 'semantic-ui-react'
import styled from 'styled-components'

export const SelectedContent = styled.div<{$defaultCursor?: boolean}>`
 display: flex;
 align-items: baseline;
 gap: 10px;
 width: 200px;
 border: 1px solid rgba(34, 36, 38, .15);
 padding: 5px;
 border-radius: 8px;
 justify-content: space-between;
 margin-bottom: 5px;
 background: white;

 .title {
   white-space: nowrap;
   overflow: hidden;
   text-overflow: ellipsis;
   max-width: 150px;
   cursor: ${props => props.$defaultCursor ? 'default' : 'pointer'};
 }
}
`
export const SelectedWrapper = styled.div`
  display: flex;
  align-items: baseline;
  gap: 15px;
  flex-wrap: wrap;
  margin-top: 2em;
  margin-bottom: 1em;
`
export const TableActionWrapper = styled.div`
display: flex;
justify-content: space-between;
margin-bottom: 10px;
margin-top: 20px;
align-items: center;
`
export const AssignedContent = styled(Label)`
display: flex !important;
align-items: center !important;
background: white !important;
border: 1px solid #74c404 !important;
padding: .3833em .833em !important;
`